import client from '../../services/session/apiClient';
import {upsertUserPreferences, userPreferences} from '../../services/users/usersApi'

import mockTemplates from './reportsAndTemplates';
import React from "react"
import presignedExport from '../../services/auth/presignedExport';

let annotatedTemplates = {
  reports: mockTemplates.reports.map((tpl, index) => ({ id: `report-${index}`, ...tpl }))
};
let flatAnnotatedTemplates = [...annotatedTemplates.reports];

export default {
  getReports: (params = {}) => {
    return client.get('/v5/insights/reports', { params }).then(response => response.data);
  },
  getReport: (reportId) => {
    return client.get(`/v5/insights/report/${reportId}`).then(response => response.data);
  },
  getTemplates: () => {
    //return client.get(`/v5/insights/templates`).then(response => response.data);
    return Promise.resolve(annotatedTemplates);
  },
  getTemplate: (id) => {
    return Promise.resolve(flatAnnotatedTemplates.find(tpl => tpl.id === id))
  },
  saveReport: (report) => {
    return client.post('/v5/insights/reports', report);
  },
  deleteReport: (reportId) => {
    return client.delete(`/v5/insights/reports/${reportId}`);
  },
  saveComponent: (component) => {
    return client.post(`/v5/insights/components`, component).then(response => response.data);
  },
  getComponents: (params = {}) => {
    return client.get('/v5/insights/components', { params }).then(response => response.data);
  },
  getComponentReports: (componentId) => {
    return client.get(`/v5/insights/components/reports/${componentId}`).then(response => response.data);
  },
  deleteComponent: (componentId) => {
    return client.delete(`/v5/insights/components/${componentId}`)
  },
  saveDataSource: (dataSource) => {
    return client.post(`/v5/insights/dataSources`, dataSource).then(response => response.data);
  },
  getDataSources: (params = {}) => {
    return client.get('/v5/insights/dataSources', { params }).then(response => {
      return response.data
    });
  },
  getDataSource: (id) => {
    return client.get('/v5/insights/dataSources/' + id).then(response => response.data);
  },
  deleteDataSource: (dataSourceId) => {
    return client.delete(`/v5/insights/dataSources/${dataSourceId}`);
  },
  getReportData: (query,  maxResults) => {
    return client.post('/v5/insights/data/query', {
      query,
      maxResults
    }).then(response => response.data);
  },
  executeGeneratedQuery: (dataSource, maxResults) => {
    return client.post('/v5/insights/data/generatedQuery', dataSource).then(response => response.data);
  },
  exportDataSource: (query,  format) => {
    return client.post('/v5/insights/data/query/export', {
      query,
      format
    }).then(response => response.data);
  },
  exportGeneratedQuery: (query) => {
    return client.post('/v5/insights/data/generatedQuery/export', query)
        .then(response => response.data);
  },
  getUserPreferences: (userId) => {
    return userPreferences(userId)
  },
  upsertUserPreferences: (userPreferences) => {
    return upsertUserPreferences({userId: userPreferences.userId, userPreferences})
  },
  getUserRoles: () => {
    return client.get('/v5/userRoles').then(response => response.data);
  },
  getAlerts: (params = {}) => {
    return client.get("/v5/alerts", { params }).then(response => response.data);
  },
  saveAlert: (params = {}) => {
    return client.post('/v5/alerts', params).then(response => response.data);
  },
  deleteAlert: (alertId) => {
    return client.delete(`/v5/alerts/${alertId}`);
  },
  getDataSchema: () => {
    return client.get(`/v5/insights/schema`).then(response => response.data);
  },
  downloadReport: (reportId, reportParams) => {
    presignedExport.downloadExport(`/v5/insights/reports/${encodeURIComponent(reportId)}/rendered`, reportParams)
  },
  getCredentials: () => {
    return client.get('/v5/insights/loadCredentials').then(resp =>  resp.data);
  },
  getUserCode: () => {
    return client.get(`/v5/insights/userCode`).then(resp => resp.data);
  }
}
